import axios from "axios";

// Cari verisini PDF şablonunun ihtiyaç duyduğu 3 ayrı bölüme ayırır:
// ödenen (gerçek ödemeler), vadesiGelmis (şu an tahsil edilebilir borç),
// planlanan (henüz vadesi gelmemiş gelecek borç). Önceden bu üçü tek bir
// "bekliyor" etiketi altında karışıyordu; artık ekrandaki (FirmaCariModal)
// ayrımla birebir aynı.
export function buildCariPdfSections(cariData) {
  const vadesiGelmis = (cariData?.borclar || [])
    .filter((b) => Number(b.kalan_tutar || 0) > 0)
    .map((b) => ({
      urun_adi: b.urun_adi || "-",
      tutar: Number(b.kalan_tutar),
      planlanan_tarih: (b.donem_baslangic || b.tarih)
        ? new Date(b.donem_baslangic || b.tarih).toLocaleDateString("tr-TR")
        : "-",
      aciklama: b.urun_aciklama || b.aciklama || "-",
    }));

  const planlanan = (cariData?.gelecek_borclar || []).map((b) => ({
    urun_adi: b.urun_adi || "-",
    tutar: Number(b.tutar || 0),
    planlanan_tarih: (b.donem_baslangic || b.tarih)
      ? new Date(b.donem_baslangic || b.tarih).toLocaleDateString("tr-TR")
      : "-",
    aciklama: b.urun_aciklama || b.aciklama || "-",
  }));

  const odenen = (cariData?.hareketler || [])
    .filter((h) => h.hareket_tipi === "ODEME")
    .map((h) => ({
      urun_adi: "-",
      tutar: Math.abs(Number(h.tutar || 0)),
      odeme_tarihi: h.tarih ? new Date(h.tarih).toLocaleDateString("tr-TR") : "-",
      aciklama: h.aciklama || "-",
    }));

  return { odenen, vadesiGelmis, planlanan };
}

export async function openCariPdf({ nodeURL, firmaAdi, cariData }) {
  const { odenen, vadesiGelmis, planlanan } = buildCariPdfSections(cariData);
  const response = await axios.post(
    `${nodeURL}/cariPdfOlustur`,
    { firmaAdi: firmaAdi || "Firma", odenen, vadesiGelmis, planlanan },
    {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    }
  );
  const blob = new Blob([response.data], { type: "application/pdf" });
  const pdfURL = window.URL.createObjectURL(blob);
  window.open(pdfURL);
}
